import { motion } from "framer-motion";
import { MessageCircle, Instagram, Sparkles } from "lucide-react";
import { SITE, buildWhatsappURL } from "@/data/site";

export default function CommunityCTA() {
  return (
    <section data-testid="community-section" className="relative py-24 md:py-32 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-[2rem] glass-strong grain p-8 md:p-14 overflow-hidden"
        >
          <div className="absolute -top-20 -left-20 w-72 h-72 bg-[#62794d]/30 blur-3xl rounded-full" />
          <div className="absolute -bottom-20 -right-10 w-72 h-72 bg-[#A7D38B]/20 blur-3xl rounded-full" />

          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-7">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-[#62794d]/20 border border-[#A7D38B]/30 text-[#A7D38B] text-[11px] px-2.5 py-1">
                <Sparkles size={12} /> The Nomikai Tribe
              </span>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-4 tracking-tighter text-white">
                Join the <span className="text-[#A7D38B] italic">Nomikai</span> community.
              </h2>
              <p className="mt-4 text-neutral-300 max-w-xl">
                Get weekly drops, secret pop-ups, surprise dinners and friends
                across India before you even check in.
              </p>
            </div>
            <div className="md:col-span-5 flex flex-col gap-3">
              <a
                href={buildWhatsappURL({ message: "Add me to the GoNomikai community!" })}
                target="_blank"
                rel="noreferrer"
                data-testid="join-whatsapp-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#62794d] text-[#f5f0ea] px-6 py-3.5 font-semibold text-sm hover:bg-[#7a9261] active:scale-[0.98] transition"
              >
                <MessageCircle size={18} /> Join the WhatsApp group
              </a>
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="join-ig-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full glass px-6 py-3.5 font-semibold text-sm hover:bg-white/10 transition text-white"
              >
                <Instagram size={18} /> Follow @gonomikai
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
